var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block z-50 sticky-section-header top-0",class:this.id},[_c('div',{staticClass:"sm:inline-block duration-150 p-3 -mt-3 -mx-3 rounded-lg",class:{
        'stuck shadow-xl bg-white dark:bg-midnight bg-opacity-75 dark:bg-opacity-75': _vm.stuck
      }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }